<template>
  <div>
    <div v-if="loading" style="margin-top:3.5rem;"><LoadingText /></div>
    <div v-else>
      <template v-for="(item,index) in list" >
        <!-- 三天内或者查看历史状态 -->
        <v-row style="margin:0;" v-if="$moment().diff(item.STATE_TIME, 'day') < 2 || !filter3DayBefore" :key="index"  >
          <v-col :cols="6" style="padding:0.3rem;">
            <span>{{$moment(item.STATE_TIME).format("YYYY-MM-DD HH:mm:ss")}}</span>
          </v-col>
          <v-col :cols="6" style="padding:0.3rem 0;">
            <span v-if="item.STATE_CODE === '1'" style="color:#67C23A">上线</span>
            <span v-else style="color:#F56C6C">离线</span>
          </v-col>
        </v-row>
      </template>
      <div v-if="list.length === 0" style="text-align:center;margin-top:2rem;color:#9e9e9e;font-size:0.8rem;">
          暂无历史记录
      </div>
      <div v-else>
        <div style="text-align:center;margin:1.3rem 0 0.5rem;" v-if="filter3DayBefore">
          <div style="color:#9e9e9e;margin-bottom:1rem;font-size:0.8rem;" v-if="!has3DayData">最近 3 天没有记录</div>
          <v-btn color="primary" style="width:13rem;margin-top:0.5rem;" @click="clickLookHist" outlined>查看历史</v-btn>
        </div>
        <div v-else>
          <div style="text-align:center;margin:1.3rem 0 0.5rem;" v-if="hasMore">
            <v-btn color="primary" style="width:13rem;" @click="clickLoadMore" outlined>加载更多</v-btn>
          </div>
          <div v-else style="text-align:center;font-size:0.8rem;color:#9e9e9e;margin-top:1rem;">
            没有更多数据 !
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingText from '@/views/components/LoadingText'
export default {
  components: {
    LoadingText
  },
  props: {
    iotId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      list: [],
      // 是否有更多数据
      hasMore: true,
      pageIndex: 1,
      pageCount: 10,
      // 是否过滤3天内记录
      filter3DayBefore: true,
      // 加载状态
      loading: true,
      // 是否3天内有记录
      has3DayData: false
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    that.$nextTick(() => {
      that.init()
    })
  },
  created() {
  },
  methods: {
    // 初始化
    async init() {
      var that = this
      await that.getDevOnlineHist()
      if (that.list.length > 0) {
        var firstRow = that.list[0]
        var d = that.$moment().diff(firstRow.STATE_TIME, 'day')
        // console.log('d', d);
        that.has3DayData = d < 2;
      }
      that.loading = false
    },
    // 根据分页获取历史数据
    async getDevOnlineHist() {
      var that = this
      var res = await that.$api.iot.getOnlineHist({ iot_id: that.iotId, page_index: that.pageIndex, page_count: that.pageCount })
      // console.log('getOnlineHist.res', res);
      if (!res.success) {
        // that.$toast.error('获取状态历史失败')
        console.log('获取设备状态历史失败', res);
        return
      }
      var data = res.data;
      if (data.length == 0) {
        that.hasMore = false;
        return
      }
      that.hasMore = data.length >= that.pageCount;
      for (let index = 0; index < data.length; index++) {
        const item = data[index];
        that.list.push(item);
      }
    },
    // 查看更多
    clickLoadMore() {
      var that = this
      that.pageIndex++;
      that.getDevOnlineHist();
    },
    // 查看历史
    async clickLookHist() {
      var that = this
      that.loading = true
      that.list = []
      that.filter3DayBefore = false
      await that.getDevOnlineHist()
      that.loading = false
    }
  }
}
</script>

<style scoped>
</style>
